/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ApplicationRef, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from 'environments/environment';
import { AppModule } from 'app/app.module';
import { enableDebugTools } from '@angular/platform-browser';
import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';

const BOOT_LOADER_READY_EVENT = 'rtls-loader-ready';

if (environment.production) {
    enableProdMode();

    if (window) {
        window.console.log = () => { };
    }

}

try {
    config({ licenseKey });
} catch (err) {
    // eslint-disable-next-line no-console
    console.error('Failed to configure De l key:', err);
}

const externalLoader = (globalThis as any).__rtlsLoader;
externalLoader?.setAngularReady?.(false);

function normalizeBootLoaderWaitMs(value: unknown): number {
    if (!Number.isFinite(value)) {
        return 1500;
    }

    return Math.max(0, Math.floor(Number(value)));
}

function waitForBootLoaderReady(maxWaitMs: number): Promise<void> {
    if (typeof window === 'undefined') {
        return Promise.resolve();
    }

    if ((window as any).__rtlsBootLoaderReady === true) {
        return Promise.resolve();
    }

    return new Promise((resolve) => {
        let settled = false;
        const timeoutMs = normalizeBootLoaderWaitMs(maxWaitMs);
        const onReady = () => finalize();
        const timeoutId = window.setTimeout(() => finalize(), timeoutMs);

        const finalize = () => {
            if (settled) {
                return;
            }

            settled = true;
            window.clearTimeout(timeoutId);
            window.removeEventListener(BOOT_LOADER_READY_EVENT, onReady);
            resolve();
        };

        window.addEventListener(BOOT_LOADER_READY_EVENT, onReady, { once: true });

        if ((window as any).__rtlsBootLoaderReady === true) {
            finalize();
        }
    });
}

async function bootstrapAngularApp() {
    if (!environment.production) {
        await import('@angular/compiler');
    }

    if (environment.bootLoaderGate?.enabled) {
        await waitForBootLoaderReady(environment.bootLoaderGate.maxWaitMs);
    }

    return platformBrowserDynamic().bootstrapModule(AppModule);
}

bootstrapAngularApp()
    .then(module => {
        externalLoader?.setAngularReady?.(true);
        if (!environment.production) {
            enableDebugTools(module.injector.get(ApplicationRef).components[0]);
        }
    })
    .catch(err => {
        externalLoader?.setAngularReady?.(false);
        console.error(err);
    });

/*
platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
*/

//console debugger --> ng.profiler.timeChangeDetection()
